<template>
  <div class="upload carregar-arquivo">
    <b-row
      class="mb-2"
      align-h="center"
    >
      <b-col
        v-if="valueInner.length == 0"
        class="mx-3 drag-drop-area texto"
      >
        <div>
          <font-awesome-icon
            :icon="faCloud"
            class="text-secondary mr-50"
            style="font-size:1.3rem !important;width:22px"
          />
          <span>Arraste e solte</span>
        </div>
      </b-col>
      <b-col
        v-else
        class="mx-3 "
      >
        <b-row class="texto">
          <b-col cols="12">
            <font-awesome-icon
              :icon="faCloud"
              class="text-secondary mr-50"
              style="font-size:1.3rem !important;width:22px"
            />
            <span style="word-break: break-all;">
              {{ valueInner[0].name }}
            </span>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <span style="margin-left: 2.5rem;display:block;font-size:small">
              {{ humanFileSize(valueInner[0].size, true) }}
            </span>
          </b-col>
        </b-row>
      </b-col>

    </b-row>
    <b-row
      align-h="center"
      class="mb-2"
    >
      <b-col cols="auto">
        <file-upload
          ref="upload"
          v-model="valueInner"
          :input-id="identificadorUnico"
          class="btn btn-sm btn-primary"
          :accept="'.pdf'"
          :multiple="false"
          :drop="true"
          :size="maxSize || 0"
          :thread="3"
          @input-filter="inputFilter"
          @input-file="inputFile"
        >
          Procure um arquivo
        </file-upload>
      </b-col>
    </b-row>
  </div>
</template>

<style lang="scss">
.carregar-arquivo {
  // @import "~@/vendor/styles/theme-paper.scss";

  .loading {
    // display: flex;
    // align-items: center;
    // padding: 10px;
    border-radius: 4px;

    .sk-double-bounce {
      margin: 13px !important;
    }
  }

  .icon {
    font-size: 25px;
    color: #549fc7;
    opacity: 0.84;
  }

  .btn-link {
    cursor: pointer;
    // color: $primary-color !important;
    color: #549fc7 !important;
    &:hover {
      color: #549fc7 !important;
      opacity: 0.65;
    }
  }

  .upload-detail {
    font-size: 12.5px;
  }

  .drag-drop-area {
    height: 75px;
    border: 2px dashed rgb(166, 152, 152);
  }

  .texto {
    font-size: 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
}
</style>

<script>
// <style src="@/vendor/libs/spinkit/spinkit.scss" lang="scss"></style>
/* eslint-disable no-param-reassign */

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faCloud,
} from '@fortawesome/free-solid-svg-icons'
import FileUpload from 'vue-upload-component'
import mixins from '@/shared/mixins/upload/Upload.vue'

export default {
  name: 'CarregarArquivo',
  components: {
    FileUpload,
    FontAwesomeIcon,
  },
  mixins: [mixins],
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      faCloud,
      identificadorUnico: Date.now().toString(36) + Math.random().toString(36).substring(2),
      maxSize: 536870912, // 512mb
      valueInner: [],
      loading: false,
      extensions: 'gif;jpg;jpeg;png;webp;pdf;doc',
    }
  },
  methods: {
    inputFilter(newFile, oldFile, prevent) {
      const file = newFile
      if (file && !oldFile) {
        if (this.isDangerFile(file.name)) {
          this.$error('Arquivos não permitidos')
          return prevent()
        }

        if (!this.allowExtension(file.name, this.extensions)) {
          this.$warning(`Apenas arquivos ${this.extensions} são permitidos`)
          return prevent()
        }
      }

      if (file && (!oldFile || file.file !== oldFile.file)) {
        file.url = ''
        const URL = window.URL || window.webkitURL
        if (URL && URL.createObjectURL) {
          file.url = URL.createObjectURL(file.file)
        }
      }
      return null
    },
    inputFile(newFile, oldFile) {
      if (newFile && oldFile) {
        if (newFile.active && !oldFile.active && this.maxSize) {
          if (this.invalidFileSize(this.maxSize, newFile.size)) {
            this.$refs.upload.update(newFile, { error: 'Tamanho inválido' })
          }
        }

        if (newFile.error && !oldFile.error) {
          this.$error(`Não foi possível salvar o arquivo ${newFile.name}. ${newFile.error}`)
          this.$refs.upload.remove(newFile)
        }
      }
    },
    getFormDataBody(body) {
      const formData = new window.FormData()
      const file = this.valueInner[0]
      if (file) {
        formData.append('file', file.file, file.filename || file.name)
      }
      formData.append('body', body)

      return formData
    },
    getFile() {
      return this.valueInner[0]
    },
  },
}
</script>
